export const periodRange = (year: number, period: number): string => {
  if (
    !Number.isInteger(year) ||
    year < 1000 ||
    year > 9999 ||
    !Number.isInteger(period) ||
    period < 1 ||
    period > 6
  )
    return '';
  const month = (period - 1) * 2;
  const lastDay = new Date(year, month + 2, 0).getDate();
  return `${year}-${String(month + 1).padStart(2, '0')}-01_${year}-${String(month + 2).padStart(2, '0')}-${lastDay}`;
};

export const periodForRange = (range: string): number => {
  const year = Number(range.slice(0, 4));
  return [1, 2, 3, 4, 5, 6].find(period => periodRange(year, period) === range) || 0;
};

export const validServiceRange = (range: string): boolean => {
  if (!/^\d{4}-\d{2}-\d{2}_\d{4}-\d{2}-\d{2}$/.test(range)) return false;
  const [start, end] = range.split('_');
  const dates = [start, end].map(value => new Date(value));
  return (
    dates.every(
      (date, i) =>
        !Number.isNaN(date.getTime()) && date.toISOString().slice(0, 10) === [start, end][i]
    ) &&
    end >= start &&
    (dates[1].getTime() - dates[0].getTime()) / 86400000 < 366
  );
};
